import { render, staticRenderFns } from "./SubscribeBox.vue?vue&type=template&id=94510232&"
import script from "./SubscribeBox.vue?vue&type=script&lang=js&"
export * from "./SubscribeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports